import "./style.scss"
interface Props {
  title: string
  dark?: boolean
}
export const CheckRow = ({ title, dark = false }: Props) => {
  return (
    <div className="check-row">
      <div className="check-row__icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="24" height="24" rx="12" fill="#e41e1f" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.037 8.61157L10.027 17.6215L4.96387 12.5584L7.19653 10.3257L10.027 13.1562L16.8043 6.37891L19.037 8.61157Z"
            fill="white"
          />
        </svg>
      </div>
      <div className="check-row__text">{title}</div>
    </div>
  )
}
